import ApiService from "@/common/api.service";
import { GET_ALL_GOODS, GET_GOOD_DETAIL, GET_LIST_GOODS } from "./actions.type";
import {
  SET_LIST_GOODS,
  SET_ERROR_GOODS,
  SET_GOOD_DETAIL,
  SET_GOOD_DETAIL_ERROR,
  SET_ALL_GOODS
} from "./mutations.type";

const state = {
  errors: [],
  goods: [],
  goodsDetail: {},
  goodsDetailErrors: [],
  allGoods: []
};

const getters = {
  goods(state) {
    return state.goods;
  },
  goodsDetail(state) {
    return state.goodsDetail;
  },
  allGoods(state) {
    return state.allGoods;
  }
};

const actions = {
  [GET_ALL_GOODS]({ commit }) {
    ApiService.get(
      "v1/products/with_category",
      `${process.env.VUE_APP_CATEGORY_ID}?offset=0&limit=100`
    )
      .then((response) => {
        commit(SET_ALL_GOODS, response.data);
      })
      .catch((response) => {
        commit(SET_ERROR_GOODS, response.data);
      });
  },
  [GET_LIST_GOODS]({ commit }, payload) {
    let apiQuery = `offset=${payload.offset}&limit=${payload.itemsPerPage}`;
    if (payload.sort) apiQuery += `&sort=${payload.sort}`;

    ApiService.get(
      "v1/products/with_category",
      `${payload.category_id}?${apiQuery}`
    )
      .then((response) => {
        commit(SET_LIST_GOODS, response.data);
      })
      .catch((response) => {
        commit(SET_ERROR_GOODS, response.data);
      });
  },
  [GET_GOOD_DETAIL]({ commit }, payload) {
    let apiQuery = `productImageBase64Flag=false`;
    return ApiService.get("v1/products", `${payload}?${apiQuery}`)
      .then(response => {
        commit(SET_GOOD_DETAIL, response.data);
      })
      .catch((response) => {
        commit(SET_GOOD_DETAIL_ERROR, response.data);
      });
  }
};

const mutations = {
  [SET_LIST_GOODS](state, payload) {
    state.goods = payload;
  },

  [SET_ERROR_GOODS](state, payload) {
    state.errors = payload;
  },

  [SET_GOOD_DETAIL](state, payload) {
    state.goodsDetail = payload;
  },
  [SET_ERROR_GOODS](state, payload) {
    state.goodDetailErrors = payload;
  },
  [SET_ALL_GOODS](state, payload) {
    state.allGoods = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
